import { ReactNode } from 'react'

import { Image, Text, View } from '@react-pdf/renderer'
import { PerformanceProcessPrintableAgreementHeaderFragment } from 'generated/resources/graphql'
import { compact } from 'lodash'
import moment from 'moment'

import buildUrl from 'modules/core/lib/buildUrl'
import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { MainTitle, Section } from './_Blocks'

function formatDate(date: string) {
  return dateToString(moment(date), 'ui_dmy_long')
}

export const AgreementHeader: React.FC<{
  agreement: PerformanceProcessPrintableAgreementHeaderFragment
}> = ({ agreement }) => {
  const Row: React.FC<{ title: string; children: ReactNode }> = ({ title, children }) => (
    <View style={{ display: 'flex', flexDirection: 'row' }}>
      <View>
        <Text style={{ fontWeight: 'bold' }}>{title}: </Text>
      </View>
      <View>
        <Text style={{ fontWeight: 'normal' }}>{children}</Text>
      </View>
    </View>
  )

  return (
    <Section>
      <View style={{ display: 'flex', flexDirection: 'row' }}>
        <View
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <MainTitle>
            {i18n.t('performance_process.agreements.printable_pdf.header_title')}
          </MainTitle>
          <View>
            <Row title={i18n.t('performance_process.agreements.printable_pdf.employee')}>
              {agreement.target.access?.fullName}
            </Row>
            <Row title={i18n.t('performance_process.reviews.common.reviewer')}>
              {agreement.managerEvaluation?.reviewerAccess?.fullName}
            </Row>
            {agreement.signer &&
              agreement.signer.id !== agreement.managerEvaluation?.reviewerAccess?.id && (
                <Row title={i18n.t('performance_process.agreements.printable_pdf.agreed_by')}>
                  {agreement.signer.fullName}
                </Row>
              )}
            {agreement.agreementSignedAt && (
              <Row title={i18n.t('performance_process.agreements.printable_pdf.agreed_at')}>
                {formatDate(agreement.agreementSignedAt)}
              </Row>
            )}
          </View>
        </View>
        <View
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
          }}
        >
          {agreement.process.company.logo && (
            <Image
              src={buildUrl(agreement.process.company.logo)}
              style={{ height: '24px', marginBottom: '10px' }}
            />
          )}
          <Text style={{ fontWeight: 'bold' }}>{agreement.process.company.legalName}</Text>
          <Text style={{ fontWeight: 'bold' }}>{agreement.process.name}</Text>
          <Text>
            {compact([
              formatDate(agreement.process.startsAt),
              formatDate(agreement.process.endsAt),
            ]).join(' - ')}
          </Text>
        </View>
      </View>
    </Section>
  )
}
